import React from 'react';
import './AppLayout.css';

const AppLayout = ({ 
  activeTab, 
  setActiveTab, 
  children 
}) => {
  return (
    <div className="app-layout">
      {/* Main Content Area */}
      <div className="app-content">
        {children}
      </div>

      {/* Fixed Bottom Navigation */}
      <div className="app-navbar">
        <button
          className={`nav-button ${activeTab === 'home' ? 'active' : ''}`}
          onClick={() => setActiveTab('home')}
          title="Home"
        >
          <div className="nav-icon-wrap"><span className="nav-icon">🏠</span></div>
          <span className="nav-label">Home</span>
        </button>
        <button
          className={`nav-button ${activeTab === 'requests' ? 'active' : ''}`}
          onClick={() => setActiveTab('requests')}
          title="Requests"
        >
          <div className="nav-icon-wrap"><span className="nav-icon">📋</span></div>
          <span className="nav-label">Requests</span>
        </button>
        <button
          className={`nav-button ${activeTab === 'direct-chat' ? 'active' : ''}`}
          onClick={() => setActiveTab('direct-chat')}
          title="Direct Chat"
        >
          <div className="nav-icon-wrap"><span className="nav-icon">💬</span></div>
          <span className="nav-label">Chat</span>
        </button>
        <button
          className={`nav-button ${activeTab === 'profile' ? 'active' : ''}`}
          onClick={() => setActiveTab('profile')}
          title="Profile"
        >
          <div className="nav-icon-wrap"><span className="nav-icon">👤</span></div>
          <span className="nav-label">Profile</span>
        </button>
      </div>
    </div>
  );
};

export default AppLayout;
